var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-icon-user-rank"},[_c('div',{staticClass:"p-icon-user-rank__inner",style:(_vm.setStyleObj)},[_vm._t("default",[_c('img',{attrs:{"src":"/assets/img/common/icon/icon-dummy.png","alt":""}})])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }